module.exports = __webpack_public_path__ + "img/5.3f1389ab.png";